import type { SignatureSharedCreateGuestSignatureMutation } from './createAsGuest.graphql';
import type { SignPetitionAsGuestResult } from './types';

export function normalizeSignPetitionAsGuestResponse(
	gqlResponse: SignatureSharedCreateGuestSignatureMutation['signPetitionAsGuest'],
): SignPetitionAsGuestResult {
	switch (gqlResponse.__typename) {
		case 'SignPetitionAsGuestSuccess':
			return { status: 'success', redirectUrl: gqlResponse.redirectUrl };
		case 'SignPetitionAsGuestInvalidCaptcha':
			return { status: 'error', reason: 'captcha' };
		case 'SignPetitionAsGuestGraylisted':
			return { status: 'error', reason: 'grayListed' };
		case 'SignPetitionAsGuestInvalidEmail':
			return { status: 'error', reason: 'invalidEmail' };
		case 'SignPetitionAsGuestLoginStateMismatch':
			return { status: 'error', reason: 'loginStateMismatch' };
		case 'SignPetitionAsGuestPendingConfirmation':
			return { status: 'error', reason: 'pendingConfirmation' };
		case 'SignPetitionAsGuestExistingAccount':
			return { status: 'error', reason: 'existingAccount', loginMethod: gqlResponse.loginMethod };
		default:
			throw new Error('Unexpected sign petition as guest mutation response typename');
	}
}
